"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addObject = exports.updateObject = exports.boundingFromPositions = exports.rectFromPolygon = exports.boundingBoxFromRect = exports.boundingBoxFromPolygon = exports.floorPoint = exports.roundPoint = exports.ceilPoint = exports.rectFromBoundingBox = exports.boundingBoxToPolygon = exports.rectToPolygon = exports.getDistance = exports.rotatePoints = exports.findNeededOrigin = exports.pivotPoint = exports.getNearestPriorFrame = exports.drawDashedRect = exports.drawDashedBoundingBox = exports.drawDashedPolygon = exports.getPixiRectFromPoints = exports.getRectFromPoints = exports.dataURLtoBlob = exports.dataUrlToTexture = exports.getTextureFromBlob = exports.bufferToBase64 = exports.getBlobFromTexture = exports.rectsEqual = exports.getBlobFromSprite = exports.getDataURLFromTexture = exports.resolveColliderType = exports.circleContainsPoint = exports.deg2rad = exports.applyParentBonesToCollider = exports.applyRotationToCollider = exports.applyScaleToCollider = exports.rad2deg = exports.roundRadian = exports.round = exports.applyCascadedBoneData = exports.isFunction = exports.logPoint = exports.roundToNearest = exports.deltaPoints = exports.inherittedTransformItemHasDeltas = exports.FrameFromType = exports.blobToDataURL = exports.shapeDataToArray = exports.rectsCollide = exports.rectContainsPoint = void 0;
exports.httpGetAsync = exports.validateSkinParam = exports.validateSkinParams = exports.removeObject = void 0;
function rectContainsPoint(r, p) {
    r = normalizeRectData(r);
    return p.x >= r.x && p.x <= r.x + r.w && p.y > r.y && p.y < r.y + r.h;
}
exports.rectContainsPoint = rectContainsPoint;
function rectsCollide(r, r2) {
    r = normalizeRectData(r);
    r2 = normalizeRectData(r2);
    return r.x + r.w >= r2.x && r.x <= r2.x + r2.w && r.y + r.h >= r2.y && r.y <= r2.y + r2.h;
}
exports.rectsCollide = rectsCollide;
function shapeDataToArray(shapeData) {
    const type = resolveColliderType(shapeData);
    switch (type) {
        case 'rect':
            shapeData = shapeData;
            // @ts-ignore
            return [shapeData.x, shapeData.y, shapeData.w, shapeData.h];
        case 'polygon':
            shapeData = shapeData;
            return shapeData.map(d => {
                return [d.x, d.y];
                // @ts-ignore
            }).flat();
        case 'circle':
            shapeData = shapeData;
            return [shapeData.r, shapeData.cx, shapeData.cy];
        case 'point':
            shapeData = shapeData;
            return [shapeData.x, shapeData.y];
    }
}
exports.shapeDataToArray = shapeDataToArray;
//**blob to dataURL**
function blobToDataURL(blob) {
    return __awaiter(this, void 0, void 0, function* () {
        const a = new FileReader();
        return new Promise((resolve, reject) => {
            a.readAsDataURL(blob);
            a.onload = (e) => {
                return resolve(e.target.result);
            };
        });
    });
}
exports.blobToDataURL = blobToDataURL;
var FrameFromType;
(function (FrameFromType) {
    FrameFromType[FrameFromType["ATTACHMENT_SETUP"] = 0] = "ATTACHMENT_SETUP";
    FrameFromType[FrameFromType["SUB_ATTACHMENT_SETUP"] = 1] = "SUB_ATTACHMENT_SETUP";
    FrameFromType[FrameFromType["ANIMATION_FRAME"] = 2] = "ANIMATION_FRAME";
})(FrameFromType = exports.FrameFromType || (exports.FrameFromType = {}));
function inherittedTransformItemHasDeltas(data) {
    return data.scaleX != 1 || data.scaleY != 1 && data.rotation != 0 || data.x != 0 || data.y != 0;
}
exports.inherittedTransformItemHasDeltas = inherittedTransformItemHasDeltas;
function deltaPoints(p1, p2) {
    return {
        x: p1.x - p2.x,
        y: p1.y - p2.y,
    };
}
exports.deltaPoints = deltaPoints;
function roundToNearest(number, multiple, method = 'ceil') {
    const round = Math[method];
    const sign = Math.sign(number) || 1;
    return (round((Math.abs(number)) * multiple) / multiple) * sign;
}
exports.roundToNearest = roundToNearest;
function logPoint(p, title, logMethod = 'log') {
    if (title) {
        console[logMethod](`Point: ${title}, X: ${p.x}, Y: ${p.y}`);
    }
    else {
        console[logMethod]('X:', p.x, 'Y:', p.y);
    }
}
exports.logPoint = logPoint;
function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
exports.isFunction = isFunction;
function applyCascadedBoneData(id, allData, debug = false) {
    const DEBUG_BONE_NAME = '';
    const item = allData.find(b => b.id == id);
    //console.log('passed in id:', id, 'all data:', allData)
    const frames = allData.find(d => d.id == id).sortedFrames;
    // last frame decides if its visible.
    const finalFrameData = { x: 0, y: 0, rotation: 0, scaleX: 0, scaleY: 0, visible: frames[frames.length - 1].visible, slotId: frames[0].slotId, };
    for (let i = 0; i < frames.length; i++) {
        const { x, y, rotation, scaleX, scaleY, visible, slotId } = frames[i];
        finalFrameData.x += x;
        finalFrameData.y += y;
        finalFrameData.rotation += rotation;
        finalFrameData.scaleX += (scaleX - 1);
        finalFrameData.scaleY += (scaleY - 1);
        if (!visible || (slotId && finalFrameData.slotId !== slotId)) {
            finalFrameData.slotId = slotId;
        }
    }
    // console.log('the cascaded frames were', frames);
    //  console.log('ITEM PARENT ID:', item.parentId);
    if (item.parentId) {
        const foundParent = allData.find(b => b.id == item.parentId);
        if (foundParent) {
            const parentData = applyCascadedBoneData(item.parentId, allData);
            finalFrameData.x += parentData.x;
            finalFrameData.y += parentData.y;
            finalFrameData.rotation += parentData.rotation;
            if (parentData.rotation) {
                //  const before = { ...finalFrameData };
                //  console.log('rotation:', parentData.rotation, 'in radians:', deg2rad(parentData.rotation));
                //  logPoint( finalFrameData, 'BEFORE PIVOT', 'error');
                const { x: px, y: py } = pivotPoint(finalFrameData, parentData, deg2rad(parentData.rotation));
                finalFrameData.x = px;
                finalFrameData.y = py;
                //  logPoint(finalFrameData, 'AFTER PIVOT', 'error');
                //   console.log('delta was', deltaPoints(before, finalFrameData), 'error')
            }
            finalFrameData.scaleX += (parentData.scaleX - 1);
            finalFrameData.scaleY += (parentData.scaleY - 1);
        }
        else {
            console.warn('Cascading frame data on an item that has a parentId but the parent does not have frame data in the array.');
        }
    }
    finalFrameData.x = Math.round(finalFrameData.x);
    finalFrameData.y = Math.round(finalFrameData.y);
    finalFrameData.rotation = Math.round(finalFrameData.rotation);
    if (debug) {
        console.log('FINAL FRAME DATA;', finalFrameData);
    }
    finalFrameData.scaleX++;
    finalFrameData.scaleY++;
    // console.log('final scale:', finalFrameData.scaleX);
    //  console.log('final scale:', finalFrameData.scaleY)
    // last frame determines if its visible.
    //  console.log('last frame visible:', frames[frames.length-1].visible);
    finalFrameData.visible = frames[frames.length - 1].visible;
    return finalFrameData;
}
exports.applyCascadedBoneData = applyCascadedBoneData;
function round(v) {
    return Math.sign(v) * Math.round(Math.abs(v));
}
exports.round = round;
function roundRadian(rad) {
    return deg2rad(Math.round(rad2deg(rad)));
}
exports.roundRadian = roundRadian;
function rad2deg(rad, round = false) {
    if (round) {
        return Math.round(rad * (180 / Math.PI));
    }
    else {
        return rad * (180 / Math.PI);
    }
}
exports.rad2deg = rad2deg;
function applyScaleToCollider(scaleX, scaleY, shapeData) {
    return shapeData;
}
exports.applyScaleToCollider = applyScaleToCollider;
function applyRotationToCollider(rotation, shapeData) {
    return shapeData;
}
exports.applyRotationToCollider = applyRotationToCollider;
function applyParentBonesToCollider(shapeData, parentBoneId, data) {
    return shapeData;
}
exports.applyParentBonesToCollider = applyParentBonesToCollider;
function deg2rad(degree) {
    return degree / (180 / Math.PI);
}
exports.deg2rad = deg2rad;
function circleContainsPoint(c, p) {
    const { cx, cy, r } = c;
    const { x, y } = p;
    const dist = (x - cx) * (x - cx) + (y - cy) * (y - cy);
    // console.log('DISTANCE WAS', dist, 'r*r was', r*r);
    if (dist < r * r) {
        return true;
    }
    return false;
}
exports.circleContainsPoint = circleContainsPoint;
function resolveColliderType(shapeData) {
    if (Array.isArray(shapeData)) {
        return 'polygon';
    }
    if ('r' in shapeData) {
        return 'circle';
    }
    if ('x' in shapeData) {
        if ('w' in shapeData) {
            return 'rect';
        }
        return 'point';
    }
    else {
        //console.error(shapeData);
        throw new Error(`Invalid shape data found on collider`);
    }
}
exports.resolveColliderType = resolveColliderType;
function getDataURLFromTexture(renderer, texture) {
    return __awaiter(this, void 0, void 0, function* () {
        const blob = yield getBlobFromTexture(renderer, texture);
        return blobToDataURL(blob);
    });
}
exports.getDataURLFromTexture = getDataURLFromTexture;
function getBlobFromSprite(renderer, displayObject) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            renderer.extract.canvas(displayObject).toBlob((blob) => {
                return resolve(blob);
            });
        });
    });
}
exports.getBlobFromSprite = getBlobFromSprite;
function rectsEqual(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.w === rect2.w && rect1.h === rect2.h;
}
exports.rectsEqual = rectsEqual;
function getBlobFromTexture(renderer, texture) {
    return __awaiter(this, void 0, void 0, function* () {
        return getBlobFromSprite(renderer, new PIXI.Sprite(texture));
    });
}
exports.getBlobFromTexture = getBlobFromTexture;
function bufferToBase64(arrayBuffer) {
    return btoa(new Uint8Array(arrayBuffer)
        .reduce((data, byte) => data + String.fromCharCode(byte), ''));
}
exports.bufferToBase64 = bufferToBase64;
function getTextureFromBlob(blob) {
    return __awaiter(this, void 0, void 0, function* () {
        const URL = window.URL || window.webkitURL;
        let blobURL;
        let needRevoke = true;
        try {
            blobURL = URL.createObjectURL(blob);
        }
        catch (err) {
            needRevoke = false;
            const base64 = bufferToBase64(blob);
            blobURL = 'data:image/png;base64,' + base64;
            // return PIXI.Texture.from(base64);
        }
        const img = new Image();
        return new Promise((resolve, reject) => {
            img.src = blobURL;
            // @ts-ignore
            img.addEventListener("load", (event) => {
                if (needRevoke) {
                    {
                        URL.revokeObjectURL(blobURL);
                    }
                }
                return resolve(new PIXI.Texture(new PIXI.BaseTexture(img)));
            }); // onload revoke the blob URL (because the browser has loaded and parsed the image data)
        });
    });
}
exports.getTextureFromBlob = getTextureFromBlob;
/*

export async function getTextureFromBlob(blob: Blob) : Promise<PIXI.Texture> {
    const blobURL = URL.createObjectURL(blob);
    const img = new Image();
    return new Promise((resolve, reject) => {
        img.src = blobURL;
        // @ts-ignore
        img.addEventListener("load", (event) => {
            {URL.revokeObjectURL(blobURL);}
            return resolve(new PIXI.Texture(new PIXI.BaseTexture(img)));
        });// onload revoke the blob URL (because the browser has loaded and parsed the image data)
    })
}
 */
function dataUrlToTexture(dataUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        return getTextureFromBlob(dataURLtoBlob(dataUrl));
    });
}
exports.dataUrlToTexture = dataUrlToTexture;
function dataURLtoBlob(dataurl) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
exports.dataURLtoBlob = dataURLtoBlob;
function getRectFromPoints(p1, p2) {
    const maxX = Math.round(Math.max(p1.x, p2.x));
    const minX = Math.round(Math.min(p1.x, p2.x));
    const maxY = Math.round(Math.max(p1.y, p2.y));
    const minY = Math.round(Math.min(p1.y, p2.y));
    return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
exports.getRectFromPoints = getRectFromPoints;
function getPixiRectFromPoints(p1, p2) {
    const { x, y, w, h } = getRectFromPoints(p1, p2);
    return new PIXI.Rectangle(x, y, w, h);
}
exports.getPixiRectFromPoints = getPixiRectFromPoints;
//https://codepen.io/unrealnl/pen/aYaxBW
function drawDashedPolygon(g, points, x, y, rotation, dash, gap, offsetPercentage = 0, color1, color2) {
    let p1;
    let p2;
    let dashLeft = 0;
    let gapLeft = 0;
    if (offsetPercentage > 0) {
        var progressOffset = (dash + gap) * offsetPercentage;
        if (progressOffset < dash)
            dashLeft = dash - progressOffset;
        else
            gapLeft = gap - (progressOffset - dash);
    }
    const rotatedPoints = rotation !== null ? rotatePoints(points, rotation) : points;
    let curLine = 0;
    for (let i = 0; i < rotatedPoints.length; i++) {
        p1 = rotatedPoints[i];
        if (i == rotatedPoints.length - 1)
            p2 = rotatedPoints[0];
        else
            p2 = rotatedPoints[i + 1];
        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const len = Math.sqrt(dx * dx + dy * dy);
        const normal = { x: dx / len, y: dy / len };
        let progressOnLine = 0;
        g.moveTo(x + p1.x + gapLeft * normal.x, y + p1.y + gapLeft * normal.y);
        while (progressOnLine <= len) {
            if (color1 !== undefined && color1 !== null && color2 !== undefined && color2 !== null) {
                g.lineColor = curLine % 2 === 0 ? color1 : color2;
            }
            curLine++;
            progressOnLine += gapLeft;
            if (dashLeft > 0)
                progressOnLine += dashLeft;
            else
                progressOnLine += dash;
            if (progressOnLine > len) {
                dashLeft = progressOnLine - len;
                progressOnLine = len;
            }
            else {
                dashLeft = 0;
            }
            g.lineTo(x + p1.x + progressOnLine * normal.x, y + p1.y + progressOnLine * normal.y);
            progressOnLine += gap;
            if (progressOnLine > len && dashLeft == 0) {
                gapLeft = progressOnLine - len;
            }
            else {
                gapLeft = 0;
                g.moveTo(x + p1.x + progressOnLine * normal.x, y + p1.y + progressOnLine * normal.y);
            }
        }
    }
}
exports.drawDashedPolygon = drawDashedPolygon;
function drawDashedBoundingBox(g, bb, x, y, rotation, dash, gap, offsetPercentage = 0, color1, color2) {
    return drawDashedPolygon(g, boundingBoxToPolygon(bb), x, y, rotation, dash, gap, offsetPercentage, color1, color2);
}
exports.drawDashedBoundingBox = drawDashedBoundingBox;
function normalizeRectData(rect) {
    if (Array.isArray(rect)) {
        if (rect.length > 4) {
            throw new Error(`Rect is longer than length 4.`);
        }
        return { x: rect[0], y: rect[1], h: rect[2], w: rect[3] };
    }
    if (!('x' in rect) || !('y' in rect)) {
        throw new Error(`Can not normalize rect`);
    }
    if ('width' in rect && 'height' in rect) {
        return { x: rect.x, y: rect.y, w: rect.width, h: rect.height };
    }
    else if ('w' in rect && 'h' in rect) {
        return rect;
    }
    else {
        throw new Error(`Can not normalize rect`);
    }
}
function drawDashedRect(g, rect, rotation, dash, gap, offsetPercentage = 0, color1, color2) {
    const bb = boundingBoxFromRect(normalizeRectData(rect));
    return drawDashedPolygon(g, boundingBoxToPolygon(bb), 0, 0, rotation, dash, gap, offsetPercentage, color1, color2);
}
exports.drawDashedRect = drawDashedRect;
function getNearestPriorFrame(frameTime, frames) {
    // if the length of the array is 0... theres obviously no previous, return null.
    if (!frames.length)
        return null;
    // gets first frame thats over or equal to the current frametime, then the previous one is which were looking for.
    const found = frames.find(d => d.time >= frameTime);
    // if we didnt find any that means the frame before is going to wind up being the last one.
    if (!found)
        return frames[frames.length - 1];
    const index = frames.indexOf(found);
    // if index was 0, there is no previous, return null.
    if (!index)
        return null;
    return frames[index - 1];
}
exports.getNearestPriorFrame = getNearestPriorFrame;
//todo: unpivot point
function pivotPoint(pointToPivot, pivotPoint, radians) {
    var originalX = pointToPivot.x;
    var originalY = pointToPivot.y;
    var angle = radians;
    var cosTheta = Math.cos(angle);
    var sinTheta = Math.sin(angle);
    var x = (cosTheta * (originalX - pivotPoint.x) -
        sinTheta * (originalY - pivotPoint.y) + pivotPoint.x);
    var y = (sinTheta * (originalX - pivotPoint.x) +
        cosTheta * (originalY - pivotPoint.y) + pivotPoint.y);
    return { x, y };
}
exports.pivotPoint = pivotPoint;
function findNeededOrigin(currentPoint, radians) {
}
exports.findNeededOrigin = findNeededOrigin;
function rotatePoints(points, rotation) {
    return points.map(point => {
        const p = { x: point.x, y: point.y };
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(rotation);
        const dx = p.x;
        const dy = p.y;
        p.x = (dx * cosAngle - dy * sinAngle);
        p.y = (dx * sinAngle + dy * cosAngle);
        return p;
    });
}
exports.rotatePoints = rotatePoints;
function getDistance(p, p2) {
    const { x, y } = p;
    const { x: x2, y: y2 } = p2;
    return Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
}
exports.getDistance = getDistance;
function rectToPolygon(rect) {
    return boundingBoxToPolygon(boundingBoxFromRect(rect));
}
exports.rectToPolygon = rectToPolygon;
function boundingBoxToPolygon(bb) {
    const { minX, minY, maxX, maxY } = bb;
    return [
        { x: minX, y: minY },
        { x: maxX, y: minY },
        { x: maxX, y: maxY },
        { x: minX, y: maxY },
        { x: minX, y: minY },
    ];
}
exports.boundingBoxToPolygon = boundingBoxToPolygon;
function rectFromBoundingBox(bb) {
    const { minX, maxX, minY, maxY } = bb;
    return {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY
    };
}
exports.rectFromBoundingBox = rectFromBoundingBox;
function ceilPoint(pt) {
    return {
        x: Math.ceil(pt.x),
        y: Math.ceil(pt.y)
    };
}
exports.ceilPoint = ceilPoint;
function roundPoint(pt, inPlace = false) {
    if (inPlace) {
        pt.x = Math.round(pt.x);
        pt.y = Math.round(pt.y);
        return pt;
    }
    return {
        x: Math.round(pt.x),
        y: Math.round(pt.y)
    };
}
exports.roundPoint = roundPoint;
function floorPoint(pt) {
    return {
        x: Math.floor(pt.x),
        y: Math.floor(pt.y)
    };
}
exports.floorPoint = floorPoint;
function boundingBoxFromPolygon(points) {
    if (points.length <= 3)
        throw new Error('Not enough points in polygon.');
    let maxX = points[0].x;
    let maxY = points[0].y;
    let minX = points[0].x;
    let minY = points[0].y;
    for (let i = 1; i < points.length; i++) {
        const { x, y } = points[i];
        minX = Math.min(x, minX);
        minY = Math.min(y, minY);
        maxX = Math.max(x, maxX);
        maxY = Math.max(y, maxY);
    }
    return { minX, minY, maxX, maxY };
}
exports.boundingBoxFromPolygon = boundingBoxFromPolygon;
function boundingBoxFromRect(rect) {
    rect = normalizeRectData(rect);
    const { x, y, w, h } = rect;
    return {
        minX: x,
        minY: y,
        maxX: x + w,
        maxY: y + h
    };
}
exports.boundingBoxFromRect = boundingBoxFromRect;
function rectFromPolygon(points) {
    return rectFromBoundingBox(boundingBoxFromPolygon(points));
}
exports.rectFromPolygon = rectFromPolygon;
function boundingFromPositions(p1, p2) {
    return {
        minX: Math.min(p1.x, p2.x),
        maxX: Math.max(p1.x, p2.x),
        minY: Math.min(p1.y, p2.y),
        maxY: Math.max(p1.y, p2.y)
    };
}
exports.boundingFromPositions = boundingFromPositions;
function updateObject(mainObject, updatedObject) {
    for (let globalDatumKey in mainObject) {
        const updatedItem = updatedObject[globalDatumKey];
        if (!updatedItem)
            continue;
        const currentItem = mainObject[globalDatumKey];
        if (Array.isArray(mainObject[globalDatumKey])) {
            updatedItem.forEach(datum => {
                const found = currentItem.find(curDatum => curDatum.id == datum.id);
                if (found) { // found it in current, so replace.
                    currentItem[currentItem.indexOf(found)] = datum;
                }
                else {
                    currentItem.push(datum);
                }
            });
        }
    }
}
exports.updateObject = updateObject;
function addObject(mainObject, updatedObject) {
    for (let globalDatumKey in mainObject) {
        const updatedItem = updatedObject[globalDatumKey];
        if (!updatedItem)
            continue;
        const currentItem = mainObject[globalDatumKey];
        if (Array.isArray(mainObject[globalDatumKey])) {
        }
    }
}
exports.addObject = addObject;
function removeObject(mainObject, addedObject) {
}
exports.removeObject = removeObject;
function validateSkinParams(params, idLookup, nameLookup) {
    const valid = [], invalid = [];
    for (let i = 0; i < params.length; i++) {
        try {
            validateSkinParam(params[i], idLookup, nameLookup);
            valid.push(params[i]);
        }
        catch (err) {
            invalid.push({ param: params[i], error: err.message ? err.message : err });
        }
    }
    return { valid, invalid, };
}
exports.validateSkinParams = validateSkinParams;
function validateSkinParam(param, idLookup, nameLookup) {
    // default these to nulls if they're not objects so we can use this function in array.filter/maps w/o issue.
    const error = (msg) => {
        //console.error('invalid param:', param);
        //idLookup && //console.error('id lookup:', idLookup);
        // nameLookup && //console.error('name lookup:', nameLookup);
        //console.error(msg);
        throw new Error(msg);
    };
    try {
        if (!param.atlasName && !param.atlasId) {
            error(`No atlasId or atlasName property in the SkinParam: ${JSON.stringify(param)}`);
        }
        if (!param.skinName && !param.skinUrl) {
            error(`No skinName or atlasName property in the SkinParam: ${JSON.stringify(param)}`);
        }
        if (param.atlasId && idLookup && (!(param.atlasId in idLookup))) {
            error(`Invalid atlas id: ${param.atlasId}, it was not found in the lookup.`);
        }
        if (param.atlasName && nameLookup && (!(param.atlasName in nameLookup))) {
            error(`Invalid atlas name: ${param.atlasId}, it was not found in the lookup.`);
        }
    }
    catch (err) {
        throw err;
    }
}
exports.validateSkinParam = validateSkinParam;
function httpGetAsync(url, parseJson = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const xmlHttp = new XMLHttpRequest();
        if (!parseJson) {
            xmlHttp.responseType = "arraybuffer";
        }
        xmlHttp.open("GET", url, true); // true for asynchronous
        xmlHttp.send(null);
        return new Promise((resolve, reject) => {
            xmlHttp.onreadystatechange = () => {
                if (xmlHttp.readyState == 4) {
                    if (xmlHttp.status == 200) {
                        return parseJson ? resolve(JSON.parse(xmlHttp.responseText)) : resolve(xmlHttp.response);
                    }
                    else {
                        try {
                            return parseJson ? reject(JSON.parse(xmlHttp.responseText)) : reject(xmlHttp.response);
                        }
                        catch (err) {
                            //console.error('Error parsing http error response', xmlHttp);
                            return reject(err);
                        }
                    }
                }
            };
        });
    });
}
exports.httpGetAsync = httpGetAsync;
//# sourceMappingURL=module.js.map